import React from 'react';

import PropTypes from 'prop-types';

import { XSS_FILTER_OPTIONS } from 'constants/Constants';

import { filterXSS } from 'xss';

import { Container, RowButton, SubTitle, Title } from './styles';
import { Button } from '../../Button/Button';

export const HeaderPanel = (props) => {
    return (
        <Container indentCompact={props.indentCompact} indentSmall={props.indentSmall}>
            <Title isCentered={props.isCentered}>{props.title}</Title>
            {props.subtitle && <SubTitle dangerouslySetInnerHTML={{ __html: filterXSS(props.subtitle, XSS_FILTER_OPTIONS) }} />}
            {!props.isGlobalFlow && props.buttonRowCaption && (
                <RowButton addTopMargin={props.addTopMargin}>
                    <Button
                        type={props.buttonRowType}
                        variant="row"
                        size={props.buttonRowSizeFit ? 'fit' : 'tight'}
                        negativeMargin
                        caption={props.buttonRowCaption}
                        onClick={props.buttonRowOnClick}
                        href={props.buttonRowHref}
                    />
                </RowButton>
            )}
        </Container>
    );
};

HeaderPanel.propTypes = {
    isGlobalFlow: PropTypes.bool,
    indentCompact: PropTypes.bool, // отступ до контента 32 на мобильных (когда после заголовка идет текст)
    indentSmall: PropTypes.bool, // отступ до контента 16 на мобильных (когда после заголовка идет сепаратор)
    isCentered: PropTypes.bool,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    buttonRowType: PropTypes.string,
    buttonRowCaption: PropTypes.string,
    buttonRowOnClick: PropTypes.func,
    buttonRowHref: PropTypes.string,
    addTopMargin: PropTypes.bool,
    buttonRowSizeFit: PropTypes.bool,
};
